import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { baseStyles } from '../../styles/base';
import type { CtaCard } from './entities';

@customElement('umb-market-cta-card')
export class UmbMarketCtaCard extends LitElement {
  @property({ type: Object })
  model!: CtaCard;

  #backgroundColor?: string;

  #textColor?: string;

  connectedCallback(): void {
    super.connectedCallback();

    this.#backgroundColor = this.model.backgroundColor;
    this.#textColor = this.#backgroundColor === 'var(--uui-color-default)'
      ? 'var(--uui-color-surface)'
      : 'var(--uui-color-current-contrast)';
  }

  render() {
    return html`
      <a
        href=${this.model.link}
        style="--my-shadow-color:${this.#backgroundColor}"
      >
        <div
          class="card-header"
          style="background-color:${this.#backgroundColor}"
        >
          <h4 style="color: ${this.#textColor}">${this.model.title}</h4>
          ${when(
            this.model.subtitle,
            () =>
              html`<p style="color: ${this.#textColor}">
                ${this.model.subtitle}
              </p>`
          )}
        </div>
        <div
          class="card-body"
          style="background-color:${this.#backgroundColor}; color:${this
            .#textColor}"
        >
          ${this.model.icon}
        </div>
      </a>
    `;
  }

  static styles = [
    baseStyles,
    css`
      :host {
        --border-radius: 22px;
      }

      @media (min-width: 600px) {
        :host {
          width: 80%;
        }
      }

      @media (min-width: 767px) {
        :host {
          width: 50%;
        }
      }

      a {
        display: flex;
        flex-direction: row-reverse;
        position: relative;
        text-decoration: none;
        border-radius: var(--border-radius);
        transition: box-shadow 240ms;
      }

      a:hover {
        box-shadow: var(--my-shadow-color) 0 0 12px 0;
      }

      .card-header,
      .card-body {
        padding: var(--m-spacer);
      }

      .card-header {
        border-radius: 0 var(--border-radius) var(--border-radius) 0;
        padding-left: 0;
      }

      .card-body {
        border-radius: var(--border-radius) 0 0 var(--border-radius);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 140px;
      }

      h4 {
        margin: 0;
        line-height: 31px;
        font-size: 24px;
        font-weight: 500;
      }

      p {
        margin-top: var(--s-spacer);
        display: block;
        font-size: 16px;
        font-weight: 300;
      }

      /* size matches icon in category page banner */
      svg {
        width: 64px;
        height: 64px;
        stroke-width:1.5;
      }
    `,
  ];
}
